import { render } from "./Entrust.vue?vue&type=template&id=58d38942&scoped=true&ts=true"
import script from "./Entrust.vue?vue&type=script&lang=ts"
export * from "./Entrust.vue?vue&type=script&lang=ts"

import "./Entrust.vue?vue&type=style&index=0&id=58d38942&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d38942"]])

export default __exports__